import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { SignOffReportModel } from "src/app/model/SignOffReportModel";
import { SignOffReportService } from "src/app/services/sign-off-report.service";

@Component({
  selector: "app-secure-signoff-report-list",
  templateUrl: "./signoff-report-list.component.html",
  styleUrls: ["./signoff-report-list.component.scss"],
})
export class SignOffReportListComponent implements OnInit {
  page: Page<SignOffReportModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<SignOffReportModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "reportName",
    "reportType",
    "status",
    "createdDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private signOffReportService: SignOffReportService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.currentPage = 0;
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    this.signOffReportService.fetchFilterList(this.currentPage, this.pageSize, this.filterForm.value.filterText)
      .subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.currentPage = 0;
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Report Name", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  downloadSignedOff(key: number) {
    this.isLoading = true;
    this.signOffReportService.downloadSignedOff(key)
    .subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  downloadSignedOffAudit(key: number) {
    this.isLoading = true;
    this.signOffReportService.downloadSignedOffAuditTrail(key)
    .subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  checkStatus(key: number) {
    this.isLoading = true;
    this.signOffReportService.checkStatus(key)
    .subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.onLoad();
      }
      else {
        this.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();
    link.remove();
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}